import React from 'react';
import { Box, Button, Typography, Container, Paper } from '@mui/material';
import { Refresh as RefreshIcon, ErrorOutline as ErrorIcon } from '@mui/icons-material';

interface ErrorWithRetryProps {
    title?: string;
    message?: string;
    onRetry: () => void;
    isRetrying?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

const ErrorWithRetry: React.FC<ErrorWithRetryProps> = ({
    title = 'Chyba při načítání',
    message = 'Nepodařilo se načíst data ze serveru.',
    onRetry,
    isRetrying = false,
    maxWidth = 'sm',
}) => {
    return (
        <Container maxWidth={maxWidth} sx={{ mt: 4 }}>
            <Paper
                elevation={0}
                sx={{
                    p: 4,
                    textAlign: 'center',
                    borderRadius: 2,
                    bgcolor: 'error.light',
                    opacity: 0.9,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        mb: 2,
                    }}
                >
                    <ErrorIcon
                        sx={{
                            fontSize: 64,
                            color: 'error.dark',
                        }}
                    />
                </Box>

                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{ fontWeight: 'bold', color: 'error.dark' }}
                >
                    {title}
                </Typography>

                <Typography
                    variant="body1"
                    sx={{ mb: 3, color: 'error.dark' }}
                >
                    {message}
                </Typography>

                <Button
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={onRetry}
                    disabled={isRetrying}
                    startIcon={
                        <RefreshIcon
                            sx={{
                                animation: isRetrying ? 'spin 1s linear infinite' : 'none',
                                '@keyframes spin': {
                                    '0%': { transform: 'rotate(0deg)' },
                                    '100%': { transform: 'rotate(360deg)' },
                                },
                            }}
                        />
                    }
                    sx={{ px: 4 }}
                >
                    {isRetrying ? 'Načítání...' : 'Zkusit znovu'}
                </Button>
            </Paper>
        </Container>
    );
};

export default ErrorWithRetry;
